<template>
	<div id="Scanner" :key="rerenderCount">
		<ScanBatches
			v-if="registered"
			@unregister="setUnregistered"
			:has-active-party="hasActiveParty"
		/>
		<Register v-if="!registered"
			@setHasActiveParty="setHasActiveParty"
		/>
		<LoadingSpinner v-if="display_loader" />
		<Message v-if="display_message" />
		<ConnectingToServer v-if="!connected" />
	</div>
</template>

<script>
	import ConnectingToServer from './components/ConnectingToServer.vue'
	import Message from './components/Message.vue'
	import LoadingSpinner from './components/LoadingSpinner.vue'
	import Register from './components/Register.vue'
	import ScanBatches from './components/ScanBatches.vue'
	export default {
		name: 'Scanner',
		components: {
			ConnectingToServer,
			Message,
			LoadingSpinner,
			Register,
			ScanBatches,
		},
		data() {
			return {
				rerenderCount: 0,
				connected: false,
				registered: false,
				display_message: false,
				display_loader: false,
				hasActiveParty: false,
			}
		},
		computed: {
			//registered: function () { return this.$scanner.registered; },
		},
		beforeCreate() { /* #### Global Functions #### */ },
		created() { },
		mounted() {
			this.display_loader = false
			this.$scanner._rerender = this.ReRender
			this.$scanner.message._display = this.Message
			this.$scanner.loader._display = this.Loading
			this.$scanner._connection = this.Connect
			this.$scanner.setRegistered = this.setRegistered
			this.$scanner.setUnregistered = this.setUnregistered
			this.$scanner.connect()
		},
		methods: {
			ReRender() { this.renderCount = ++this.$scanner.renderCount },
			Message(display = true) { this.display_message = this.$scanner.message.display = display },
			Loading(display = true) { this.display_loader = this.$scanner.loader.display = display },
			Connect(connect = true) { this.connected = this.$scanner.loader.display = connect },
			setRegistered() { this.registered = true },
			setUnregistered() {
				localStorage.clear();
				this.registered = false;
				this.hasActiveParty = false;
			},
			setHasActiveParty() {
				this.hasActiveParty = true;
			},
		},
		beforeUpdate() { /* #### Late Load Helpers #### */ },
	}
</script>

<style>
	/* #### Defaults & Resets #### */
	/* #### Resets #### */
	html, body { display: block; min-height: 100%; min-width: 100%; background: #23282d; }
	article,aside,details,figcaption,figure,footer,header,hgroup,main,nav,section,summary{display:block}audio,canvas,video{display:inline-block}audio:not([controls]){display:none;height:0}[hidden],template{display:none}html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}a{background:transparent}a:focus{outline:thin dotted}a:active,a:hover{outline:0}h1{font-size:2em;margin:.67em 0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}hr{-moz-box-sizing:content-box;box-sizing:content-box;height:0}mark{background:#ff0;color:#000}code,kbd,pre,samp{font-family:monospace,serif;font-size:1em}pre{white-space:pre-wrap}q{quotes:"\201C" "\201D" "\2018" "\2019"}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:0}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}button,input,select,textarea{font-family:inherit;font-size:100%;margin:0}button,input{line-height:normal}button,select{text-transform:none}button,html input[type="button"],
	input[type="reset"],input[type="submit"]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}input[type="checkbox"],input[type="radio"]{box-sizing:border-box;padding:0}input[type="search"]{-webkit-appearance:textfield;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box}input[type="search"]::-webkit-search-cancel-button,input[type="search"]::-webkit-search-decoration{-webkit-appearance:none}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}textarea{overflow:auto;vertical-align:top}table{border-collapse:collapse;border-spacing:0}*,:after,:before{-moz-box-sizing:border-box;box-sizing:border-box;}html{font-size:62.5%}body{font:300 11px/1.4 'Helvetica Neue',Helvetica,Arial,sans-serif;color:#444}.clear:before,.clear:after{content:' ';display:table}.clear:after{clear:both}.clear{*zoom:1}img{max-width:100%;vertical-align:bottom}a{color:#444;text-decoration:none}a:hover{color:#444}a:focus{outline:0}a:hover,a:active{outline:0}input:focus{outline:0;border:1px solid #04A4CC}h1,h2,h3,h4,h5,h6{line-height:normal;margin:0;padding:0;}
	html, body { display: block; margin: 0; padding: 0; height: 100%; }
	body { min-height: 100%; height: auto; }
	h1, h2, h3, h4, h5, h6 { margin: 0; padding: 0; }
	* { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; }
	input, button, textarea, select { font-size: 14px; padding: 5px 10px; margin: 5px; line-height: 1.8; vertical-align: middle; }
	/* ## Selection Color ## */
	::-moz-selection, ::-webkit-selection, ::selection { background:#beba79; color:#FFF; text-shadow:none; }
	/* ## Cursor ## */
	a, button, input[type='button'], input[type='submit'] { cursor: pointer !important; }
	/* ## Outline ## */
	*.scrollto:focus, *.scrollto:active { box-shadow: none !important; outline: none !important; }
	/* ## Img ## */
	img { height: auto; }

	/* #### Main CSS Variables #### */
	:root {

		--color-red: #e14330;
		--color-green: #41b883;
		--color-blue: #063e82;
		--color-purple: #544098;
		--color-orange: #ff8d3f;
		--color-grey: #868686;

		--background-green: #cffca5;
		--background-red: #fca5a5;

		--header-height: 50px;
		--side-margins: 20px;
		--vertical-margins: 20px;

		--background: #010118;
		--text-color: #FFF;
		--link-color: #FFF;
		--link-color-hover: #12cfd5;
		--header-color: #544098;

		--button-font-size: 16px;
		--button-border: 0px none;
		--button-text-color: #FFF;
		--button-background: #544098;
		--button-border-hover: 0px none;
		--button-text-color-hover: #FFF;
		--button-background-hover: #12cfd5;
		--button-padding: 5px 15px 0px;

		--navbar-background: #063e82;
		--navbar-text-color: #FFF;
		--navbar-text-color-hover: #c8dc53;

	}

	/* #### Fonts #### */
	@font-face {
		font-family: 'Raleway';
		src: url('/fonts/raleway.eot');
		src: url('/fonts/raleway.eot?#iefix') format('embedded-opentype'),
			url('/fonts/raleway.woff2') format('woff2'),
			url('/fonts/raleway.woff') format('woff'),
			url('/fonts/raleway.ttf') format('truetype'),
			url('/fonts/raleway.svg#ralewayregular') format('svg');
		font-weight: normal;
		font-style: normal;
	}
	@font-face {
		font-family: 'Oswald';
		src: url('/fonts/oswald.eot');
		src: url('/fonts/oswald.eot?#iefix') format('embedded-opentype'),
			url('/fonts/oswald.woff2') format('woff2'),
			url('/fonts/oswald.woff') format('woff'),
			url('/fonts/oswald.ttf') format('truetype'),
			url('/fonts/oswald.svg#oswaldregular') format('svg');
		font-weight: normal;
		font-style: normal;
	}
	body { font-family: 'Raleway', Tahoma, Verdana, sans-serif; font-size: 16px; font-weight: normal; }
	h1, h2, h3, h4, h5, h6 { font-family: 'Oswald', Tahoma, Verdana, sans-serif; line-height: 1.4; font-weight: bold; letter-spacing: normal; }
	h1 { font-size: 3em; }
	h2 { font-size: 2.25em; }
	h3 { font-size: 2em; }
	h4 { font-size: 1.8em; }
	h5 { font-size: 1.6em; }
	h6 { font-size: 1.4em; }
	h1.error, h2.error, h3.error, h4.error, h5.error, h6.error {
		color: var(--color-red);
	}
	button, a.button { transition: all 0.3s ease 0.2s; display: inline-block; text-decoration: none; line-height: 1.4; font-size: var(--button-font-size); text-transform: uppercase; font-family: 'Oswald', Tahoma, Verdana, sans-serif; padding: var(--button-padding); }
	/*
	button:hover, a.button:hover { transition: all 0.3s ease 0.2s; box-shadow: 0 10px 10px -10px rgba(0,0,0,.5); -webkit-transform: scale(1.05); transform: scale(1.05); }
	button:disabled:hover, a.button:disabled:hover { box-shadow: none; -webkit-transform: scale(1); transform: scale(1); }
	 */
	.button-row::after { content: ''; display: block; clear: both; }
	button.green { background: var(--color-green); }
	button.purple { background: var(--color-purple); }
	button.grey { background: var(--color-grey); }
	form label { display: block; font-size: 14px; padding: 0px 10px; }
	form .row { display: block; padding: 20px 10px; box-sizing: border-box; }
	form .block { position: relative; display: inline-block; vertical-align: top; padding: 0px 10px; width: 50%; box-sizing: border-box; }
	form .block input { width: 100%; }
	@media only screen and (max-width: 650px) {
		form .block { width: auto; display: block; }
	}

	/* #### Background #### */
	html { background: var(--background) url('/images/background_stars_muted.png') top center repeat; background-attachment: fixed; }
	body { background: var(--background) url('/images/background_stars_muted.png') top center repeat; background-attachment: fixed; }

	/* #### Colors #### */
	body { color: var(--text-color); }
	a { color: var(--link-color); }
	/*a:hover { color: var(--link-color-hover); }*/
	h1, h2, h3, h4, h5, h6, p { color: var(--header-color); }
	button { display: inline-block; border: var(--button-border); background: var(--button-background); color: var(--button-text-color); font-size: 25px; padding-top: 10px; }
	/*
	button:hover { border: var(--button-border-hover); background: var(--button-background-hover); color: var(--button-text-color-hover); cursor: pointer; }
	 */
	button:disabled { background: #666 !important; cursor: not-allowed !important; }
	.center { text-align: center; }
	.error, .error:hover, .required { color: var(--color-red) !important; }
	.success, .success:hover { color: var(--color-green) !important; }
	a.error, a.error:hover { text-decoration: underline; color: #900 !important; }
	input.error { border: 1px solid var(--color-red); }
	.error-background { background: #fbe0d9; }
	.button-yes:hover { background: var(--color-green); }
	.button-no:hover { background: var(--color-red); }
	button i { margin: 0 6px 0 0; }
	.btn-warning { background-color: var(--color-orange); }
	.button-row { text-align: center; padding: 10px 20px; }
	input, select { font-size: 20px; height: 43px; border: 1px solid var(--color-purple); width: 200px; }

	/* ## Spaceship ## */
	@-webkit-keyframes spaceship {
		0% { -webkit-transform: translateY(-8px); transform: translateY(-8px); }
		50% { -webkit-transform: translateY(-4px); transform: translateY(-4px); }
		100% { -webkit-transform: translateY(-8px); transform: translateY(-8px); }
	}
	@keyframes spaceship {
		0% { -webkit-transform: translateY(-8px); transform: translateY(-8px); }
		50% { -webkit-transform: translateY(-4px); transform: translateY(-4px); }
		100% { -webkit-transform: translateY(-8px); transform: translateY(-8px); }
	}
	@-webkit-keyframes spaceship-float {
		100% { -webkit-transform: translateY(-8px); transform: translateY(-8px); }
	}
	@keyframes spaceship-float {
		100% { -webkit-transform: translateY(-8px); transform: translateY(-8px); }
	}
	.spaceship {
		display: inline-block;
		vertical-align: middle;
		-webkit-transform: perspective(1px) translateZ(0);
		transform: perspective(1px) translateZ(0);
		box-shadow: 0 0 1px rgba(0, 0, 0, 0);
		-webkit-animation-name: spaceship-float, spaceship;
		animation-name: spaceship-float, spaceship;
		-webkit-animation-duration: .3s, 1.5s;
		animation-duration: .3s, 1.5s;
		-webkit-animation-delay: 0s, .3s;
		animation-delay: 0s, .3s;
		-webkit-animation-timing-function: ease-out, ease-in-out;
		animation-timing-function: ease-out, ease-in-out;
		-webkit-animation-iteration-count: 1, infinite;
		animation-iteration-count: 1, infinite;
		-webkit-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
		-webkit-animation-direction: normal, alternate;
		animation-direction: normal, alternate;
	}
	.spaceship img { max-width: 80%; min-width: 200px; }

	/* #### Pulse #### */
	@keyframes pulse {
		0%   { transform: scale(1); }
		25%  { transform: scale(0.985); }
		75%  { transform: scale(1.015); }
		100% { transform: scale(1); }
	}

	/* #### Loading Dots #### */
	.loading-dots:after { display: inline-block; position: absolute; animation: loading-dots steps(2,end) 2s infinite; content: ''; }
	@keyframes loading-dots {
		0%   { content: '   '; }
		25%  { content: '.  '; }
		50%  { content: '.. '; }
		75%  { content: '...'; }
		100% { content: '   '; }
	}

	/* #### Lightbox #### */
	.fullscreen-centered {
		position: fixed;
		bottom: 0;
		top: 0;
		left: 0;
		right: 0;
		width: 100%;
		min-height: 100%;
		z-index: 999;
		background: transparent none;
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
		overflow-x: none;
		overflow-y: auto;
	}
	.fullscreen-centered>* { display: block; }

	.fullscreen-overlay {
		position: fixed;
		bottom: 0;
		top: 0;
		left: 0;
		right: 0;
		width: 100%;
		min-height: 100%;
		z-index: 999;
		background: #fff;
		overflow-x: auto;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
	}

	.overlay-header {
		padding: 0.5em;
	}

	.overlay-body {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 1.5em;
		align-content: center;
		flex-grow: 1;
	}

	.modal-invisible { overflow: scroll; }
	.interface {  z-index: 999; }
	.on-top {  z-index: 9999; }
	.usually-on-top {  z-index: 999999; }
	.always-on-top { z-index: 99999999; }
	.absolute-top { z-index: 999999999; }

	/* #### Page Styles #### */
	.white-light { background: #FFF; }
	.white-light h1,
	.white-light h2,
	.white-light h3,
	.white-light h4,
	.white-light h5,
	.white-light h6 { color: var(--color-purple); }
	.white-light,
	.white-light p { color: var(--color-blue); }
	.dark-stars { background: #010118 url('/images/background_stars_muted.png') top center repeat; background-attachment: fixed; }
	.dark-stars h1,
	.dark-stars h2,
	.dark-stars h3,
	.dark-stars h4,
	.dark-stars h5,
	.dark-stars h6 { color: #FFF; }
	.dark-stars,
	.dark-stars p { color: #FFF; }

	.hide { position: absolute; margin-left: -999em; text-indent: -999em; }
	.hidden { display: none !important; }
	.float-left { float: left; }
	.float-right { float: right; }
	.minheight { height: auto !important; overflow-y: scroll !important; min-height: 100% !important; }

	.strikethrough { text-decoration: line-through; }
	.text-centered { text-align: center; }

	.p-05 { padding: 0.5em; }
	.p-1 { padding: 1em; }

	.better-mobile-btn {
		padding: 8px 10px 4px 10px;
	}

</style>
